import { render } from "./AddToBag.vue?vue&type=template&id=c36f9f16&scoped=true"
import script from "./AddToBag.vue?vue&type=script&lang=js"
export * from "./AddToBag.vue?vue&type=script&lang=js"

import "./AddToBag.vue?vue&type=style&index=0&id=c36f9f16&lang=scss&scoped=true"
import "./AddToBag.vue?vue&type=style&index=1&id=c36f9f16&lang=scss"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36f9f16"]])

export default __exports__